// extracted by mini-css-extract-plugin
module.exports = {"card":"PricingPlansNew_card__wQnmg","highlighted":"PricingPlansNew_highlighted__1PrmN","buyButton":"PricingPlansNew_buyButton__Dkp_s"};